import React from "react"
import autobind from "class-autobind"
import { IconButton, FontIcon } from "material-ui"
import { Table, TableBody, TableFooter, TableRow, TableRowColumn } from "material-ui/Table"
import { IScheduleTemplate, IScheduleDocument } from "../../../../../models"
import AccountStore from "../../../../../stores/AccountStore"
import * as utils from "../../../../../helpers/utils"
import * as hierarchyHelper from "../../../../../helpers/hierarchyHelper"
import * as api from "../../../../../api"
import * as userHelper from "../../../../../helpers/userHelper"
import { ETemplateType } from "./AddTemplateDialogForChip"
interface IProps {
	templateType: ETemplateType
	overrideHierarchy: boolean
	hierarchyId: string
	jobId: string
	selectedTemplate: IScheduleTemplate | IScheduleDocument
	handleSelectTemplate(selectedTemplate: IScheduleTemplate | IScheduleDocument): void
}
interface IState {
	selectedTemplate: IScheduleTemplate | IScheduleDocument
	templates: (IScheduleTemplate | IScheduleDocument)[]
	offset: number
	total: number
}

export default class SelectTemplateTable extends React.Component<IProps, IState>  {
	private limit = 6
	constructor(props) {
		super(props)
		this.state = {
			selectedTemplate: null,
			templates: [],
			offset: 0,
			total: 0,
		}
		autobind(this)
	}

	componentDidMount() {
		this.getTemplates()
	}

	componentWillReceiveProps(nextProps) {
		this.setState({ selectedTemplate: nextProps.selectedTemplate })
	}

	getTemplates() {
		if (this.props.templateType === ETemplateType.ScheduleTemplate) {
			const searchedTemplates = utils.sortAlphabetical(
				AccountStore.getCurrentAccount().ScheduleData.ScheduleTemplates
					.filter(item =>
						!item.Deleted &&
						item.PatternTemplates.length !== 0 &&
						(this.props.overrideHierarchy ?
							userHelper.getSupervisorAccessHierarchyIds().includes(item.HierarchyId) :
							this.props.jobId ?
								false :
								hierarchyHelper.getHierarchyIdsForShowAllChildHierarchyData(true, this.props.hierarchyId).includes(item.HierarchyId)
						)
					),
				"Name"
			)

			const filteredTemplates = searchedTemplates.slice(this.state.offset, this.state.offset + this.limit)
			this.setState({
				templates: filteredTemplates,
				selectedTemplate: null,
				total: searchedTemplates.length,
			})
		}
		else {
			(!this.props.overrideHierarchy && this.props.jobId) ?
				api.getJobMasterSchedules(this.state.offset / this.limit, this.limit, "", this.props.jobId).then(res =>
					this.setState({
						total: res.data.TotalDocumentCount,
						templates: res.data.Documents,
						selectedTemplate: null
					})
				) :
				api.getMasterSchedules(
					AccountStore.getCurrentAccount().Id,
					this.state.offset / this.limit,
					this.limit,
					"",
					this.props.overrideHierarchy ? "" : this.props.hierarchyId ? this.props.hierarchyId : "",
					true,
					this.props.overrideHierarchy
				).then(res =>
					this.setState({
						total: res.data.TotalDocumentCount,
						templates: res.data.Documents,
						selectedTemplate: null
					})
				)
		}

		this.props.handleSelectTemplate(null)
	}

	offsetChange(offset) {
		this.setState({ offset }, () => this.getTemplates())
	}

	render() {
		return (
			<div>
				<div style={{ height: 300 }}>
					<Table
						onCellClick={rowNumber =>
							this.setState({ selectedTemplate: this.state.templates[rowNumber] }, () =>
								this.props.handleSelectTemplate(this.state.selectedTemplate)
							)
						}
						multiSelectable={false}
					>
						<TableBody showRowHover={true} deselectOnClickaway={false}>
							{this.state.templates.map((row, i) =>
								<TableRow data-intercom-target={`SelectTemplate-SelectRow${i + 1}`} key={row.Id} selected={this.state.selectedTemplate && this.state.selectedTemplate.Id === row.Id} style={{ border: "hidden" }}>
									<TableRowColumn style={{ cursor: "pointer" }}>{row.Name}</TableRowColumn>
								</TableRow>
							)}
						</TableBody>
					</Table>
				</div>
				<Table>
					<TableBody />
					<TableFooter>
						<TableRow className="TableFooter" style={{ borderBottom: 0 }}>
							<TableRowColumn style={{ float: "right" }}>
								<IconButton data-intercom-target={"SelectTemplate-Btn-OpenFirstPage"} disabled={this.state.offset === 0} onClick={() => this.offsetChange(0)}>
									<FontIcon className="fa fa-step-backward" />
								</IconButton>
								<IconButton data-intercom-target={"SelectTemplate-Btn-OpenPreviousPage"} disabled={this.state.offset === 0} onClick={() => this.offsetChange(this.state.offset - this.limit)}>
									<FontIcon className="fa fa-chevron-left" />
								</IconButton>
								<IconButton data-intercom-target={"SelectTemplate-Btn-OpenNextPage"} disabled={this.state.offset + this.limit >= this.state.total} onClick={() => this.offsetChange(this.state.offset + this.limit)}>
									<FontIcon className="fa fa-chevron-right" />
								</IconButton>
								<IconButton data-intercom-target={"SelectTemplate-Btn-OpenLastPage"} disabled={this.state.offset + this.limit >= this.state.total} onClick={() => this.state.total % this.limit === 0 ? this.offsetChange(this.state.total - this.limit) : this.offsetChange(this.state.total - (this.state.total % this.limit))}>
									<FontIcon className="fa fa-step-forward" />
								</IconButton>
							</TableRowColumn>
						</TableRow>
					</TableFooter>
				</Table>
			</div>
		)
	}
}
